import React from 'react';

import {PANEL_TYPES} from "../../baseFunctions";

export default class PanelEditor extends React.Component {
	constructor(props){
		super(props);
		this.addPanel = this.addPanel.bind(this);
		this.updatePanel = this.updatePanel.bind(this);
		this.movePanel = this.movePanel.bind(this);
		this.state = {
			panels: props.panels
		};
	}
	
	addPanel()
	{
		this.setState({
			panels: [...this.state.panels, {
				type: Object.keys(PANEL_TYPES)[0]
			}]
		});
	}
	movePanel(i, way)
	{
		let newI = way === "left" ? i - 1 : i + 1;
		let panelData = this.state.panels.filter((d, key) => key !== i);
		this.setState({
			panels: [
				...panelData.filter((d, key) => key < newI),
				{...this.state.panels[i]},
				...panelData.filter((d, key) => key >= newI),
			]
		});
	}
	updatePanel(i, e)
	{
		let target = e.target;
		let panels = [...this.state.panels];

		console.log("Update panel #", i, target);
		panels[i][e.target.name] = e.target.value;
		this.setState({panels});
	}

	render(){
		console.log(PANEL_TYPES);
		const PANEL_SIZES = {
            "third": "col-md-4 col-sm-4 col-xs-4",
            "half": "col-md-6 col-sm-6 col-xs-6",
            "halfFull": "col-md-6 col-sm-6 col-xs-12",
            "full": "col-md-12 col-sm-12 col-xs-12",
        };
		return (
		<div>
		<div className="container">
		<div className="row">
		{
			this.state.panels.map((d, pKey) => {
				let panelData = d.type ? PANEL_TYPES[d.type] : false;
				let size = panelData ? PANEL_SIZES[panelData.panelSize] : PANEL_SIZES.full;
				if(!size)
				{
					size = PANEL_SIZES.full;
				}
				/*console.log("Data", panelData, d);
				console.log(panelData.extraName && panelData.extraValue, panelData.extraName, panelData.extraValue);*/
				return (<div key={"panel" + pKey} style={{border: "1px dashed", padding: "10px"}} className={size}>
					<form onChange={(e) => this.updatePanel(pKey, e)}>
						<select name="type" defaultValue={d.type} key={d.type}>
							{
								Object.keys(PANEL_TYPES).map((key) => <option key={pKey + "option" + key} value={key}>{key}</option>)
							}
						</select>
						{
							!!panelData.extraName ? 
							<div>
								<input name={"extraValue"} placeholder={panelData.extraName} defaultValue={d.extraValue ? d.extraValue : ""}/>
							</div>
							: null
						}
					</form>

					{
						pKey > 0 ?
							<button onClick={() => this.movePanel(pKey, "left")}>&#8592;</button>
						: null
					}
					{
						pKey < (this.state.panels.length - 1) ?
							<button onClick={() => this.movePanel(pKey, "right")}>&#8594;</button>
						: null
					}

					<button onClick={() => this.setState({panels: this.state.panels.filter((d, i) => i !== pKey)})}>
						<i className="fa fa-trash" aria-hidden="true"></i>
					</button>
					
				</div>);
			})
		}
		</div>
		</div>
		<div className="container">
			<div className="row">
					<button className="col-md-6 col-sm-6 col-xs-6" style={{margin: "0px", marginTop: "20px", height: "50px"}} onClick={this.addPanel}>+</button>
					<button className="col-md-6 col-sm-6 col-xs-6" style={{margin: "0px", marginTop: "20px", height: "50px"}} onClick={() => this.props.save(this.state.panels)}>Gem</button>
				</div>
			</div>
		</div>);
	}
}


// WEBPACK FOOTER //
// ./src/components/UI/PanelEditor/PanelEditor.js